import api from '../../../../../api/api';
import Input from '../../../../../components/Input';
import usePaginatedRequest from '../../../../../hooks/usePaginatedRequest';
import useQueryParams from '../../../../../hooks/useQueryParams';
import ResolveTable from '../../../../../components/ResolveTable';
import {
  logTableColumns,
  headingTranslationsLogTable,
  logTableCellContent,
} from './data';

import './Logs.styles.scss';

function Logs() {
  const { params, setQueryParam } = useQueryParams();

  const { items, totalPages, isLoading } = usePaginatedRequest({
    getItems: api.getLogs,
    defaultParams: { limit: 10 },
    dependencies: [params],
  });

  const handleChangeSearch = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setQueryParam('filter', event.target.value);
    setQueryParam('page', 1);
  };

  return (
    <div className="logs-page">
      <div className="content-container">
        <div className="page-header">
          <p className="page-title">Logs</p>
          <Input
            name="search"
            value={params.filter}
            placeholder="Search..."
            onChange={handleChangeSearch}
          />
        </div>

        <ResolveTable
          isDataLoading={isLoading}
          totalPages={totalPages}
          data={items}
          columns={logTableColumns}
          headingTranslations={headingTranslationsLogTable}
          tableContentTransformations={logTableCellContent}
        />
      </div>
    </div>
  );
}

export default Logs;
